import script from "./MysticQuestPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./MysticQuestPanel.vue?vue&type=script&setup=true&lang=js"

import "./MysticQuestPanel.vue?vue&type=style&index=0&id=89f0ca46&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-89f0ca46"]])

export default __exports__